import React, { useState } from "react";
import { useDrop } from "react-dnd";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { Table } from "../../api";
import DraggableGuest, {
  DraggableGuestItem,
} from "../../components/DraggableGuest/DraggableGuest";
import "./DroppableTable.css";

interface Props {
  table: Table;
  handleDropGuest: (guestID: string, tableID: string) => void;
  handleRemoveGuest: (guestID: string, tableID: string) => void;
  onContextMenu?: (e: React.MouseEvent, table: Table) => void;
  onClick?: (e: React.MouseEvent, table: Table) => void;
  isDuplicateName: (name: string, allGuests: {guest_name?: string}[]) => boolean;
  allGuests: {guest_name?: string}[];
  isMobile?: boolean;
}

function DroppableTable({
  table,
  handleDropGuest,
  handleRemoveGuest,
  onContextMenu,
  onClick,
  isDuplicateName,
  allGuests,
  isMobile,
}: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  const [{ isOver }, dropRef] = useDrop({
    accept: "guest",
    drop: (item: DraggableGuestItem) => {
      handleDropGuest(item.guest.guest_id, table.table_id);
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const totalGuests = (guests: any[]) => {
    let sum = 0;
    guests.map((guest) => {
      sum += guest.guest_count || 0;
      return guest;
    });
    return sum;
  };

  // 计算是否超出容量
  const isOverCapacity =
    totalGuests(table.guests || []) > (table.table_guest_count || 0);

  const handleHeaderClick = (e: React.MouseEvent) => {
    if (isMobile && onClick) {
      onClick(e, table);
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const handleExpandButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      ref={dropRef}
      className="table-item"
      onContextMenu={(e) =>
        onContextMenu ? onContextMenu(e, table) : undefined
      }
      style={{ backgroundColor: isOver ? "#f0f0f0" : undefined }}
    >
      <div
        className={`table-header ${isOverCapacity ? "overflow" : ""}`}
        onClick={handleHeaderClick}
      >
        <div>
          <span className="table-name">{table.table_name}</span>
          <span className="table-count">
            {totalGuests(table.guests || [])}/{table.table_guest_count}
          </span>
        </div>
        <KeyboardArrowDownIcon
          className={`expand-btn ${isExpanded ? "expanded" : ""}`}
          onClick={handleExpandButtonClick}
        />
      </div>

      <div className={`table-content ${isExpanded ? "show" : ""}`}>
        {table.guests?.map((guest: any) => (
          <DraggableGuest
            key={guest.guest_id}
            guest={guest}
            tableID={table.table_id}
            handleRemoveGuest={handleRemoveGuest}
            isDuplicate={isDuplicateName(guest.guest_name || "", allGuests)}
            isMobile={isMobile}
          />
        ))}
        {table.guests?.length === 0 && (
          <div className="list-item">No guests at this table</div>
        )}
      </div>
    </div>
  );
}

export default DroppableTable;
